/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
const initialState = {
  reportslist: '',
  reportsNewlist: '',
  checkListAction: '',
  workplanAction: '',
  addreport: '',
  isReloadReport: false,
  reports: [],
  columnChooserUpdate: null,
};

const reportReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'reportslist':
      return {
        ...state,
        reportslist: action.value,
        addreport: '',
        isReloadReport: false,
        checkListAction: '',
        reportsNewlist: '',
      };
    case 'CLEAR_ADDED_REPORT':
      return {
        ...state,
        addreport: '',
        isReloadReport: false,
        checkListAction: '',
        reportsNewlist: '',
      };
    case 'reportsNewlist':
      return {
        ...state,
        reportsNewlist: action.value,
        checkListAction: '',
        addreport: '',
      };
    case 'checkListAction':
      return {
        ...state,
        checkListAction: action.value,
      };
    case 'workplanAction':
      return {
        ...state,
        workplanAction: action.value,
      };
    case 'Reports':
      return {
        ...state,
        reports: action.value,
      };
    case 'addnewreport':
      return {
        ...state,
        addreport: action.value,
        isReloadReport: true,
      };
    case 'COLUMN_CHOOSER_UPDATE':
      return {
        ...state,
        columnChooserUpdate: action.value,
      };
    default:
      return state;
  }
};

export default reportReducer;
